import { render, staticRenderFns } from "./base-echart.vue?vue&type=template&id=fb1f51b6&"
import script from "./base-echart.vue?vue&type=script&lang=js&"
export * from "./base-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports